import MobileAppDevelopment from './MobileAppDevelopment'

export default MobileAppDevelopment
